import { Module } from "vuex";
import {
  IActions,
  IGetters,
  IMutations,
  ICustomerStatState,
  ICustomer,
} from "./customerStat.type";

// Cache duration: 5 minutes
const CACHE_DURATION = 5 * 60 * 1000;

export const getters: IGetters = {
  getCustomers: (state) => {
    return state.customers;
  },
  isLoading: (state) => {
    return state.loading;
  },
  isDataStale: (state) => {
    if (!state.lastLoaded) return true;
    return Date.now() - state.lastLoaded > CACHE_DURATION;
  },
};

export const mutations: IMutations = {
  setLoading: (state, payload) => {
    state.loading = payload;
  },
  setCustomers: (state, payload) => {
    state.customers = payload;
  },
  setLastLoaded: (state, payload) => {
    state.lastLoaded = payload;
  },
  clearCache: (state) => {
    state.customers = [];
    state.lastLoaded = null;
  },
};

export const actions: IActions = {
  async fetchCustomers(this, context, forceRefresh = false): Promise<void> {
    // Return cached data if available and not stale
    if (
      !forceRefresh &&
      context.state.customers.length > 0 &&
      !context.getters.isDataStale
    ) {
      return;
    }

    try {
      context.commit("setLoading", true);
      const allCustomers: ICustomer[] = [];
      let nextToken = null;

      do {
        const result: any = await this.$services.customerStat.listAllStat(nextToken);
        const newData = result.items.map((item: any) => ({
          id: item.customer.id,
          firstname: item.customer.firstname,
          lastname: item.customer.lastname,
          email: item.customer.email,
          phone_number: item.customer.phone_number,
          totalSaleVolume: item.totalSaleVolume,
          totalOrder: item.totalOrder,
          productList: item.productList,
          orderList: item.orderList,
        }));

        allCustomers.push(...newData);
        nextToken = result.nextToken;
      } while (nextToken);

      context.commit("setCustomers", allCustomers);
      context.commit("setLastLoaded", Date.now());
    } catch (err) {
      console.error("Error loading customers:", err);
    } finally {
      context.commit("setLoading", false);
    }
  },
};

const customerStat: Module<ICustomerStatState, ICustomerStatState> = {
  namespaced: true,
  state: {
    loading: false,
    customers: [],
    lastLoaded: null,
  },
  getters,
  mutations,
  actions,
};

export default customerStat;
